"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SignalStrengthV2", {
  enumerable: true,
  get: function get() {
    return _SignalStrengthV["default"];
  }
});
var _SignalStrengthV = _interopRequireDefault(require("./SignalStrengthV2"));